import React, { useEffect, useState } from 'react';
import DoctorCard from '../components/DoctorCard';
import { obtenerDoctores } from '../firebase/firestore';

// Rutas absolutas desde /public — funcionan en desarrollo y en producción
const EQUIPO_MOCK = [
  {
    nombre: 'Dra. Angie Polar',
    especialidad: 'Trauma y PTSD · EMDR',
    foto: '/image/angie.jpg',
    bio: 'Psicóloga clínica con 12 años de experiencia en trauma complejo. Certificada en EMDR y Somatic Experiencing.',
  },
  {
    nombre: 'Dr. Carlos Vega',
    especialidad: 'Ansiedad · TCC',
    foto: '/image/doctor.jpg',
    bio: 'Especialista en trastornos de ansiedad y estrés postraumático. Formado en terapia cognitivo-conductual avanzada.',
  },
  {
    nombre: 'Lic. Alex Pagnota',
    especialidad: 'Duelo · Vínculos',
    foto: '/image/doctor1.jpg',
    bio: 'Psicólogo enfocado en procesos de duelo, pérdidas y reconstrucción de la identidad en adultos.',
  },
];

export default function Equipo() {
  const [equipo, setEquipo] = useState(EQUIPO_MOCK);

  useEffect(() => {
    obtenerDoctores()
      .then((data) => { if (data.length > 0) setEquipo(data); })
      .catch(() => {});
  }, []);

  return (
    <div className="pt-24">
      {/* Header */}
      <section className="py-20 bg-teal-950 text-white">
        <div className="max-w-6xl mx-auto px-6">
          <p className="text-teal-400 text-xs uppercase tracking-widest mb-4">Quiénes somos</p>
          <h1 className="font-display text-5xl md:text-6xl mb-6">Nuestro equipo</h1>
          <p className="text-teal-200 text-lg max-w-xl leading-relaxed">
            Profesionales comprometidos con tu bienestar, formados en las terapias más efectivas
            para el trauma y la salud mental.
          </p>
        </div>
      </section>

      {/* Equipo */}
      <section className="py-24 bg-stone-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-12">
            {equipo.map((d, i) => (
              <DoctorCard key={i} {...d} />
            ))}
          </div>
        </div>
      </section>

      {/* Filosofía */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="section-title mb-6">Nuestra filosofía</h2>
          <p className="section-subtitle mx-auto text-center">
            Creemos que cada persona tiene la capacidad de sanar. Nuestro rol es acompañar ese
            proceso con presencia, conocimiento y profundo respeto por tu historia.
          </p>
        </div>
      </section>
    </div>
  );
}